import React, { useState } from 'react';
import './LandingPage.css'; 
import { useNavigate } from "react-router-dom";

export default function Navbar() {

  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleGetStarted = () => {
        navigate("/community-login");
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };


  return (
    <div className="nav-bar" style={{position:"fixed", top:0, left:0, right:0, zIndex:1000,}}>
      <div className="nav-left">
        {/* Hamburger icon for mobile */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          &#9776;
        </div>
        <div className="logo-img">
          <a  href="/home">
            <img src="./images/icons/PortOSlogo.svg" alt="PortOS logo" style={{cursor:"pointer"}}/>
          </a>
        </div>
      </div>
      
      <div className={`nav-links ${menuOpen ? 'open' : ''}`} style={{ justifyContent: "space-between", gap: "40px" }}>
        {/* <div className={`nav-links ${menuOpen ? 'open' : ''}`}> */}
          <div className="nav-item" onClick={() => scrollToSection("hero")}>Home</div>
          <div className="nav-item" onClick={() => scrollToSection("features")}>Features</div>
          <div className="nav-item" onClick={() => scrollToSection("pricing")}>Pricing</div>
          <div className="nav-item" onClick={() => scrollToSection("contactus")}>Contact us</div>
        {/* </div> */}
        <div className="log-button" onClick={handleGetStarted}>
          <span>Login</span>
        </div>
      </div>
      {/* Right-aligned Login button (always visible) */}
      <div className="nav-right">
        <div className="moblielogin-button" onClick={handleGetStarted}>
          <span>Login</span>
        </div>
      </div>
    </div>
  );
};

